/* CALLIE LEE | QUICK ADD SIZE / METAL / CUSTOMIZE V3 */
(function () {
  if (window.callieQuickAddReadyV3) return;
  window.callieQuickAddReadyV3 = true;

  const sizeAliases = {
    'xs':['xs','x-small','extra small','xsmall'],
    's':['s','small'],
    'm':['m','medium'],
    'l':['l','large'],
    'xl':['xl','x-large','extra large','xlarge']
  };
  const normalize = value => String(value || '').trim().toLowerCase().replace(/[\s_]+/g,' ');
  const sizeLabel = value => {
    const key=normalize(value).replace(/\s+/g,'');
    for(const [abbr,names] of Object.entries(sizeAliases)) {
      if(names.some(name=>name.replace(/\s+/g,'')===key))return abbr.toUpperCase();
    }
    return String(value);
  };
  const lettersOnly = value => Array.from(String(value || '').normalize('NFC').toUpperCase()).filter(char=>/^\p{L}$/u.test(char)).join('');
  const isSize = name => /size|wrist/i.test(name);
  const isMetal = name => /metal|material|jewell?ery|colour|color/i.test(name);
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  const money = cents => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency}).format(Number(cents)/100); }
    catch(e){return '$'+(Number(cents)/100).toFixed(2);}
  };
  const create = (tag,className,text) => {
    const element=document.createElement(tag);
    if(className)element.className=className;
    if(text!==undefined)element.textContent=String(text);
    return element;
  };
  function setup(wrapper) {
    if (wrapper._clQuick) return wrapper._clQuick;
    const dataTag=wrapper.querySelector('[data-cl-quick-data]');
    if(!dataTag)return null;
    let data;
    try{data=JSON.parse(dataTag.textContent);}catch(e){return null;}
    const variants=Array.isArray(data.variants)?data.variants:[];
    const available=variants.filter(v=>v.available);
    const initial=available.find(v=>v.options.some((val,i)=>isSize(data.options[i]||'') && sizeLabel(val)==='M'))||available[0]||variants[0];
    const state={data,values:initial?initial.options.slice():[], custom:wrapper.dataset.clCustomize==='true', singleLetter:false, busy:false};
    const picker=wrapper.querySelector('[data-cl-quick-picker]');
    const custom=wrapper.querySelector('[data-cl-quick-letters]');
    const error=wrapper.querySelector('[data-cl-quick-error]');
    const confirm=wrapper.querySelector('[data-cl-quick-confirm]');
    state.showError=function(message) {
      if(!error)return;
      error.textContent=message||'';
      error.hidden=!message;
    };
    state.match=function(){
      return variants.find(v=>v.options.length===state.values.length && v.options.every((o,i)=>o===state.values[i]));
    };
    state.update=function(){
      const variant=state.match();
      picker.querySelectorAll('[data-cl-quick-choice]').forEach(btn=>{
        const index=Number(btn.dataset.clQuickIndex),value=btn.dataset.clQuickChoice;
        const selected=state.values[index]===value;
        btn.setAttribute('aria-pressed',String(selected));
        btn.classList.toggle('is-selected',selected);
        const matches=available.some(v=>v.options[index]===value);
        btn.disabled=!matches;
      });
      picker.querySelectorAll('select[data-cl-quick-index]').forEach(select=>select.value=state.values[Number(select.dataset.clQuickIndex)]||'');
      const text=custom?custom.value.trim():'';
      const limit=state.singleLetter?1:8;
      const validText=!state.custom||(text.length>0&&Array.from(text).length<=limit);
      confirm.disabled=state.busy||!variant||!variant.available||!validText;
      confirm.textContent=variant?'ADD TO BAG  ·  '+money(variant.price):'UNAVAILABLE';
      if(!variant||!variant.available)state.showError('This combination is unavailable.');
      else if(state.custom&&!validText)state.showError(state.singleLetter?'Enter one letter.':'Enter up to 8 letters.');
      else state.showError('');
    };
    function switchChoice(index,value) {
      if(state.busy)return;
      const exact=available.find(v=>v.options[index]===value && v.options.every((o,i)=>i===index||o===state.values[i]));
      const candidates=available.filter(v=>v.options[index]===value);
      const candidate=exact||candidates.sort((a,b)=>b.options.reduce((sum,o,i)=>sum+(i!==index&&o===state.values[i]?1:0),0)-a.options.reduce((sum,o,i)=>sum+(i!==index&&o===state.values[i]?1:0),0))[0];
      if(candidate)state.values=candidate.options.slice();
      else state.values[index]=value;
      state.update();
    }
    if(picker){
      data.options.forEach((name,index)=>{
        const values=[...new Set(variants.map(v=>v.options[index]).filter(Boolean))];
        if(!values.length||(values.length===1&&name==='Title'))return;
        const field=create('fieldset','cl-quick-field');
        const legend=create('legend','cl-quick-field__label',isSize(name)?'SELECT SIZE':isMetal(name)?'CHOOSE METAL':String(name).toUpperCase());
        field.appendChild(legend);
        const group=create('div','cl-quick-choices');
        if(isSize(name))group.classList.add('cl-quick-choices--sizes');
        if(isMetal(name))group.classList.add('cl-quick-choices--metal');
        const singleLetters=/letter|initial/i.test(name) && values.length>=20 && values.every(v=>Array.from(v).length===1);
        if(singleLetters && custom) {
          state.singleLetter=true;
          custom.maxLength=1;
          custom.placeholder='ONE LETTER';
        }
        if(values.length>12&&!isSize(name)) {
          const select=create('select','cl-quick-select');
          select.dataset.clQuickIndex=String(index);
          select.setAttribute('aria-label',String(name));
          values.forEach(value=>{const option=create('option','',value);option.value=value;select.append(option);});
          select.addEventListener('change',()=>switchChoice(index,select.value));
          field.append(select);
        } else {
          values.forEach(value=>{
            const button=create('button','cl-quick-choice',isSize(name)?sizeLabel(value):isMetal(name)?'':value);
            button.type='button';
            button.dataset.clQuickChoice=value;
            button.dataset.clQuickIndex=String(index);
            button.setAttribute('aria-label',isMetal(name)?value:(isSize(name)?'Size ':'')+value);
            button.setAttribute('aria-pressed','false');
            if(isMetal(name)) {
              button.classList.add('cl-quick-metal');
              const color=/silver/i.test(value)?'silver':/gold/i.test(value)?'gold':'other';
              const swatch=create('span','cl-quick-swatch cl-quick-swatch--'+color);
              swatch.setAttribute('aria-hidden','true');
              button.append(swatch,create('span','cl-quick-metal-label',value));
            }
            button.addEventListener('click',()=>switchChoice(index,value));
            group.append(button);
          });
          field.append(group);
        }
        picker.append(field);
      });
    }
    if(custom){
      custom.addEventListener('input',function(){
        const max=state.singleLetter?1:8;
        const value=Array.from(lettersOnly(custom.value)).slice(0,max).join('');
        if(custom.value!==value)custom.value=value;
        if(state.singleLetter) {
          const letterIdx=data.options.findIndex(n=>/letter|initial/i.test(n));
          if(letterIdx>=0&&value) switchChoice(letterIdx,value);
        }
        state.update();
      });
    }
    wrapper._clQuick=state;state.update();return state;
  }
  async function add(wrapper,button,state) {
    if(!state||state.busy)return;
    state.update();
    if(button.disabled)return;
    const variant=state.match();
    if(!variant||!variant.available){state.showError('Choose an available option.');return;}
    const input=wrapper.querySelector('[data-cl-quick-letters]');
    const personalized=input?input.value.trim():'';
    if(state.custom&&!personalized){state.showError('Enter up to 8 letters.');return;}
    state.busy=true;const previous=button.textContent;
    button.disabled=true;button.textContent='ADDING…';
    const item={id:Number(variant.id),quantity:1};
    if(state.custom)item.properties={'Customization':personalized};
    const root=(window.Shopify?.routes?.root)||'/';
    try{
      const response=await fetch(root+'cart/add.js',{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:[item]})
      });
      const result=await response.json();
      if(!response.ok)throw Error(result.description||'Could not add this bracelet.');
      button.textContent='ADDED ✓';
      document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      try{window.Alpine?.store('xMiniCart')?.openCart();}catch(e){}
      setTimeout(()=>{
        state.busy=false;button.textContent=previous;
        const panel=wrapper.querySelector('[data-cl-quick-options]');
        const open=wrapper.querySelector('[data-cl-quick-open]');
        if(panel)panel.hidden=true;
        if(open)open.setAttribute('aria-expanded','false');
        state.update();
      },1200);
    }catch(e){
      state.busy=false;
      state.showError(e.message||'Please try again.');
      button.disabled=false;button.textContent=previous;
    }
  }
  document.addEventListener('click',event=>{
    const open=event.target.closest('[data-cl-quick-open]');
    const confirm=event.target.closest('[data-cl-quick-confirm]');
    if(!open&&!confirm)return;
    const button=confirm||open;
    const wrapper=button.closest('[data-cl-quick-add]');
    if(!wrapper)return;
    event.preventDefault();event.stopPropagation();
    if(confirm){add(wrapper,confirm,setup(wrapper));return;}
    if(open.disabled)return;
    const panel=wrapper.querySelector('[data-cl-quick-options]');
    if(!panel)return;
    const willOpen=panel.hidden;
    document.querySelectorAll('[data-cl-quick-options]:not([hidden])').forEach(other=>{
      if(other!==panel){other.hidden=true;other.closest('[data-cl-quick-add]')?.querySelector('[data-cl-quick-open]')?.setAttribute('aria-expanded','false');}
    });
    panel.hidden=!willOpen;open.setAttribute('aria-expanded',String(willOpen));
    if(willOpen){setup(wrapper);panel.querySelector('[data-cl-quick-letters]')?.focus({preventScroll:true});}
  });
})();
